import { makeQuery } from 'shared/utilities';
import { ITaskModel } from "shared/models/TaskTracker";

type RequestType = {
    id: number
};

type ResponseType = {
    item: ITaskModel
};

export const tasksProposeAcceptQuery = async function (request: RequestType) {
    return await makeQuery<ResponseType>('/tasks/propose-accept', {
        prefix: 'task-tracker',
        json: request
    });
}
